export const doAddSite = async (siteData) => {
  try {
    const response = await fetch("/sites", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(siteData),
    });
    const data = await response.json();
    return response.ok ? { success: true, site: data } : { success: false, ...data };
  } catch (error) {
    return { success: false, function: "doAddSite", stack: error.message };
  }
};